export const CHILDREN_BUSINESS_UNIT = new Set(['fund', 'company']);
export const TOP_LEVEL_BUSINESS_UNIT = new Set(['standalone', 'firm']);
export const FIRM_KIND = 'firm';
export const STANDALONE_KIND = 'standalone';
export const COMPANY_KIND = 'company';
export const FUND_KIND = 'fund';

export const FILTER_BLOCKS_SIZE = '3em';
export const DATE_INPUT_WIDTH = '8em';

export const BUSINESS_UNIT_QUERY_PARAMS = ['company', 'firm', 'fund'];
export const MAX_CHANGED_PAYLOAD_LENGTH = 100;

export const PORTFOLIO_VALUATIONS_PRODUCT = 'portfolio-valuations';
export const WORKBOARD_PRODUCT = 'workboard';
export const ALL_PRODUCTS = 'all';

export const PRODUCT_SELECTION_OPTIONS = [
  { value: WORKBOARD_PRODUCT, label: 'Workboard' },
  { value: PORTFOLIO_VALUATIONS_PRODUCT, label: 'Portfolio Valuations' },
  { value: ALL_PRODUCTS, label: 'All' },
];

/**
 * Maps product types to the business unit kinds that are valid for that product.
 * This configuration makes it easy to add new products in the future.
 */
export const PRODUCT_BUSINESS_UNIT_KINDS_MAP: Record<string, Set<string>> = {
  [WORKBOARD_PRODUCT]: new Set(['standalone']),
  [PORTFOLIO_VALUATIONS_PRODUCT]: new Set(['firm', 'fund', 'company']),
  [ALL_PRODUCTS]: new Set(['standalone', 'firm', 'fund', 'company']),
};
